export const MediaSettingsTestIds = {
  mediaSettingsContainer: 'media_settings_container',
  viewToggleButtons: 'view_toggle_buttons',
  viewModeText: 'view_mode_text',
  buttonListView: 'button_list_view',
  iconListView: 'icon_list_view',
  buttonGridView: 'button_grid_view',
  iconGridView: 'icon_grid_view',
  mediaSection: 'media_section',
  mediaList: 'media_list',
  mediaItem: 'media_item',
  checkboxSelectMessage: 'checkbox_select_message',
  mediaIcon: 'media_icon',
  messageTypeIcon: 'message_type_icon',
  mediaInfo: 'media_info',
  mediaName: 'media_name',
  mediaOwner: 'media_owner',
  mediaMeta: 'media_meta',
  mediaSize: 'media_size',
  mediaDate: 'media_date',
  noFilesMessage: 'no_files_message',
  mediaFooter: 'media_footer',
  buttonDownloadSelected: 'button_download_selected',
  mediaPaginator: 'media_paginator'
} as const;
